// Players — povýšený Průzkumník hráčů (dřív tab v Timing Analyzeru).
import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { UsersThree } from "@phosphor-icons/react";
import AppShell from "../components/AppShell";
import ContextArticles from "../components/ContextArticles";
import PlayerExplorer from "../components/timing/PlayerExplorer";
import { useSharedPool } from "../lib/timing-pool-store";

export default function Players() {
    const [searchParams] = useSearchParams();
    const initialPlayerKey = searchParams.get("player") || null;
    const [lang] = useState(() => {
        try { return localStorage.getItem("timing.lang") || "cs"; }
        catch { return "cs"; }
    });
    const sharedPool = useSharedPool();

    return (
        <AppShell>
            <div data-testid="players-page" className="space-y-5">
                <header className="border-2 border-fa-mint/40 bg-gradient-to-br from-fa-mint/10 via-transparent to-fa-sky/5 p-6">
                    <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-fa-mint flex items-center gap-2">
                        <UsersThree size={11} weight="fill" /> Players
                    </div>
                    <h1 className="font-display font-black uppercase tracking-tight text-3xl md:text-4xl mt-1">
                        Průzkumník hráčů
                    </h1>
                    <p className="font-mono text-[11px] text-white/65 mt-2 max-w-3xl leading-relaxed">
                        Historie 6 sezón, výkon dle síly soupeře, matchupy a rozpis zápasů — z detailu se proklikneš na jednotný profil hráče.
                    </p>
                </header>
                <PlayerExplorer lang={lang} sharedPool={sharedPool} initialPlayerKey={initialPlayerKey} />
                <ContextArticles category="players" />
            </div>
        </AppShell>
    );
}
